/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesNb = {
  privacy: {
    pageTitle: "Personvernerklæring",
    lastUpdated: "Sist oppdatert: 1. juni 2026",
    introduction: {
      title: "Innledning",
      body: "WasOK er en lokal hjelpeapp for shopping, laget for å hjelpe brukere med å huske produkter de tidligere har kjøpt, vurdert eller anmeldt.\n\nDenne personvernerklæringen forklarer hvilken informasjon som behandles når du bruker appen, hvordan data lagres, og hvordan enkelte tredjepartstjenester kan fungere.",
    },
    dataStored: {
      title: "Data lagret av appen",
      body: "WasOK lagrer følgende informasjon lokalt på enheten din:\n\n• skannede produktstrekkoder\n• produktnavn og detaljer angitt av brukeren\n• vurderinger og kommentarer\n• handlelister\n• produktkategorier\n• priser og butikkinformasjon\n• produkt- og butikkbilder\n\nProduktdataene og bildene dine lastes ikke opp til WasOKs servere.",
    },
    permissions: {
      title: "Tillatelser som brukes",
      camera: {
        title: "Kamera",
        body: "Kameratilgang brukes til:\n\n• strekkodeskanning\n• å ta produktbilder",
      },
      photos: {
        title: "Bilder og media",
        body: "Bilde- eller galleritilgang brukes kun når:\n\n• bilder legges ved produkter\n• sikkerhetskopier som inneholder bilder gjenopprettes",
      },
      files: {
        title: "Fil- og lagringstilgang",
        body: "Filtilgang kan brukes til:\n\n• eksport av sikkerhetskopifiler\n• import av sikkerhetskopier valgt av brukeren\n• deling av handlelister eller sikkerhetskopier",
      },
    },
    backup: {
      title: "Sikkerhetskopiering og eksport",
      body: "WasOK lar brukere opprette sikkerhetskopifiler som inneholder appdata og valgfrie bilder.\n\nSikkerhetskopifiler opprettes lokalt på enheten din og kan lagres eller deles via tjenester valgt av brukeren, for eksempel:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokal enhetslagring\n\nWasOK laster ikke opp sikkerhetskopier til egne servere.",
      onlineProductLookup: {
        title: "Online produktsøk",
        body: "Når du aktiverer online strekkodesøk i Innstillinger, kan WasOK sende kun det skannede strekkodenummeret til offentlige produktdatabaser (for eksempel Open Food Facts) for å foreslå produktnavn og merke. WasOK laster ikke opp vurderingene, kommentarene, bildene, handlelistene, kategoriene, butikkinformasjonen eller sikkerhetskopiene dine for denne funksjonen. Du kan slå dette av når som helst i Innstillinger.",
      },
    },
    advertising: {
      title: "Annonsering og tredjepartstjenester",
      intro:
        "WasOK bruker utvalgte tredjepartstjenester for å tilby enkelte funksjoner.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob brukes til å vise annonser i appen.\n\nGoogle og dets partnere kan behandle informasjon som:\n\n• annonseidentifikatorer\n• enhetsinformasjon\n• IP-adresse\n• diagnostikk- og bruksinfo\n\nBrukere i enkelte regioner kan bli bedt om samtykke før personaliserte annonser vises.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK bruker Firebase Crashlytics for å identifisere krasj og forbedre appens stabilitet.\n\nKrasjrapporter kan inneholde teknisk informasjon som:\n\n• enhetsmodell\n• operativsystemversjon\n• appversjon\n• krasjdiagnostikk\n\nKrasjrapporter inneholder ikke med hensikt produktvurderingene, notatene, handlelistene eller bildene dine.",
      },
      externalProductDatabases: {
        title: "Eksterne produktdatabaser",
        body: "Strekkodesøkefunksjonalitet kan bruke eksterne produktdatabaser for å hente produktinformasjon.\n\nFor mer informasjon, se personvernerklæringene til de respektive leverandørene.",
      },
    },
    dataSecurity: {
      title: "Datasikkerhet",
      body: "WasOK lagrer appdata lokalt på enheten din ved hjelp av lagringsmekanismer levert av operativsystemet.\n\nSelv om rimelige tiltak tas for å beskytte lokal appdata, er ingen metode for elektronisk lagring helt sikker.\n\nBrukere er selv ansvarlige for å vedlikeholde sikkerhetskopier av viktige data dersom ønskelig.",
    },
    children: {
      title: "Barns personvern",
      body: "WasOK er ikke rettet mot barn under 13 år.",
    },
    notifications: {
      title: "Varsler",
      body: "WasOK kan valgfritt opprette lokale varsler på enheten din for å minne deg på å vurdere produkter etter kjøp.\n\nDisse varslene genereres og planlegges lokalt på enheten din og krever ikke en konto eller ekstern server.\n\nDu kan deaktivere varsler når som helst via enhetsinnstillingene eller i appen, hvis støttet.",
    },
    yourControl: {
      title: "Din kontroll over data",
      body: "Du kan:\n\n• redigere eller slette lagrede produkter når som helst\n• tømme appdata fra enheten din\n• avinstallere appen\n• eksportere sikkerhetskopier av dataene dine",
    },
    changes: {
      title: "Endringer i denne erklæringen",
      body: "Denne personvernerklæringen kan oppdateres fra tid til annen.\n\nEndringer trer i kraft når den oppdaterte versjonen publiseres.",
    },
    contact: {
      title: "Kontakt",
      body: "Hvis du har spørsmål om denne personvernerklæringen, kontakt:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Vilkår for bruk",
    lastUpdated: "Sist oppdatert: 1. juni 2026",
    acceptance: {
      title: "Aksept av vilkår",
      body: "Ved å laste ned, installere eller bruke WasOK godtar du disse vilkårene for bruk.\n\nHvis du ikke godtar disse vilkårene, skal du ikke bruke appen.",
    },
    license: {
      title: "Lisens",
      body: "WasOK gir deg en begrenset, ikke-eksklusiv, ikke-overførbar, tilbakekallelig lisens til å bruke appen i samsvar med disse vilkårene.",
    },
    acceptableUse: {
      title: "Akseptabel bruk",
      body: "Du samtykker i å ikke:\n\n• misbruke appen\n• forstyrre appens drift\n• forsøke å reverse-engineere eller endre appen\n• bruke appen i strid med gjeldende lover eller forskrifter",
    },
    localData: {
      title: "Lokale data og sikkerhetskopier",
      body: "WasOK lagrer brukerdata lokalt på enheten.\n\nBrukere er selv ansvarlige for å vedlikeholde sikkerhetskopier av viktige data dersom ønskelig.\n\nSelv om sikkerhetskopiering og gjenoppretting kan tilbys, garanterer ikke WasOK mot tap, korrupsjon eller svikt i lagrede data.",
    },
    advertisements: {
      title: "Annonser",
      body: "Appen kan vise annonser levert av tredjeparts annonsepartnere, inkludert Google AdMob.",
    },
    noWarranty: {
      title: "Ingen garanti",
      body: "WasOK leveres \"som den er\" og \"som tilgjengelig\" uten garantier av noe slag, uttrykkelige eller underforståtte.\n\nVi garanterer ikke at:\n\n• appen alltid er tilgjengelig\n• appen er feilfri\n• datatap aldri skjer\n• alle funksjoner fungerer uavbrutt på alle enheter",
    },
    limitationLiability: {
      title: "Ansvarsbegrensning",
      body: "I den grad loven tillater det, skal WasOK og dens utviklere ikke holdes ansvarlige for:\n\n• datatap\n• tap av fortjeneste\n• enhetsproblemer\n• indirekte eller følgeskader\n• avbrudd som følge av bruk eller manglende evne til å bruke appen",
    },
    thirdParty: {
      title: "Tredjepartstjenester",
      body: "Enkelte funksjoner eller innhold kan være avhengig av tredjepartstjenester, inkludert annonseleverandører og eksterne lagrings-/delingstjenester valgt av brukeren.\n\nWasOK er ikke ansvarlig for tredjepartstjenester eller deres retningslinjer.",
    },
    productInformation: {
      title: "Produktinformasjon",
      body: "Enkelte produktdetaljer kan hentes fra tredjeparts strekkodesøketjenester.\n\nWasOK garanterer ikke nøyaktigheten, fullstendigheten, tilgjengeligheten eller egnetheten av informasjon fra eksterne datakilder.\n\nBrukere bør selvstendig verifisere produktinformasjon når det er nødvendig.",
    },
    changesApp: {
      title: "Endringer i appen",
      body: "WasOK kan endres, oppdateres, suspenderes eller avvikles når som helst uten forhåndsvarsel.",
    },
    changesTerms: {
      title: "Endringer i disse vilkårene",
      body: "Disse vilkårene kan oppdateres periodisk.\n\nFortsettelse av bruk av appen etter at oppdateringer trer i kraft utgjør aksept av de reviderte vilkårene.",
    },
    contact: {
      title: "Kontakt",
      body: "For spørsmål om disse vilkårene, kontakt:\n\nsupport@wasok.app",
    },
  },
};
